// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"594":"about","922":"unsubscribe"}[chunkId] + "." + {"594":"c67789a6","922":"5389a9c6"}[chunkId] + ".js";
};